<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    v-if="dialog"
  >
    <div>
      <popup-header v-on:clickClose="beforeCloseModal()" />
      <!-- 제목 -->
      <v-row class="title-wrap">
        <v-col cols="12" class="big-title sm-padding">{{
          $t('임직원 찾기')
        }}</v-col>
      </v-row>

      <!-- 검색창 -->
      <v-row class="ma-0 mb-3" style="padding-top: 5px" id="searchArea">
        <v-col cols="12" class="py-0 px-6">
          <v-text-field
            outlined
            clearable
            hide-details=""
            solo
            dense
            height="48"
            class="shadow-none search input-search"
            :append-icon="'mdi-magnify'"
            clear-icon="mdi-close-circle"
            v-model="searchKeyword"
            @change="fetchMemberList()"
            placeholder="성명, 소속 검색"
          ></v-text-field>
        </v-col>
      </v-row>

      <!-- 검색결과 -->
      <v-list flat class="overflow-y-auto" :style="scrollViewStyle">
        <v-list-item-group>
          <v-list-item
            v-for="(item, i) in searchList"
            :key="i"
            :class="{ 'custom-selected': isSelected(item) }"
            @click="toggleEmp(item)"
          >
            <v-list-item-content>
              <v-list-item-title>
                <span class="name">{{ item.name }}</span>
                <span class="sub-desc ml-2">{{ item.jikweeNm }}</span>
                <span class="sub-desc divider">{{ item.orgNm }}</span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>

      <bottom-apply-btn
        v-on:onClickApplyBtn="applySelectedData"
      ></bottom-apply-btn>
    </div>
  </v-dialog>
</template>

<script>
/*
 * 임직원검색 모달_ver2
 *  - 다건 선택 가능
 *  - 부서명, 직원명으로 검색 가능
 */
import PopupHeader from '@/components/common/PopupHeader.vue';
import BottomApplyBtn from '@/components/common/BottomApplyBtn.vue';
import { getMemberList } from '@/api/member.js';
import dialogMixin from '@/mixins/dialogMixin.js'; // ** dialog Mixin **

export default {
  mixins: [dialogMixin],

  props: {
    // * 기선택된 임직원 목록 (직원 선택 시 중복검사하기 위해)
    existEmpList: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    modalName: 'search_executives_multi',

    searchKeyword: '', // * 검색어
    searchList: [], // * 조회결과 목록
    selectedEmployees: [], // * 선택된 임직원 목록
  }),

  computed: {
    GET_USER_DATA() {
      return this.$store.getters.GET_USER_DATA;
    },

    scrollViewStyle() {
      const searchAreaHeight = 69; // 검색창 높이

      return `max-height: ${
        window.innerHeight - (this.vt_header_title_button + searchAreaHeight)
      }px`;
    },
  },

  created() {
    this.fetchMemberList(); // ** 컴포넌트 생성 시 임직원정보목록조회
  },

  methods: {
    /* 임직원선택 토글 */
    toggleEmp(emp) {
      // 이미 선택된 임직원 목록에 있는지 확인
      if (this.existEmpList.some(e => e.sabun === emp.sabun)) {
        alert('이미 적용된 직원입니다.');
        return;
      }

      const idx = this.selectedEmployees.findIndex(e => e.sabun === emp.sabun);
      if (idx > -1) {
        this.selectedEmployees.splice(idx, 1); // 이미 있으면 제거
      } else {
        this.selectedEmployees.push(emp); // 없으면 추가
      }
    },

    /* 선택여부 확인 */
    isSelected(emp) {
      return this.selectedEmployees.some(e => e.sabun === emp.sabun);
    },

    /* 적용버튼 클릭 -> 부모화면에 데이터전달 */
    applySelectedData() {
      this.$emit('applySelectedData', this.selectedEmployees); // ** 부모 컴포넌트로 선택된 목록 전달

      this.closeModal();
      this.selectedEmployees = []; // ** 선택된 목록초기화
    },

    /* 모달 닫기 전 처리 */
    beforeCloseModal() {
      this.closeModal();
      this.selectedEmployees = []; // ** 선택된 목록초기화
    },

    /* 임직원정보목록조회 */
    async fetchMemberList() {
      const searchObj = {
        ssnEnterCd: this.GET_USER_DATA.ssnEnterCd,
        ssnSabun: this.GET_USER_DATA.ssnSabun,
        searchIncludeRa: 'N',
        searchNameOrg: this.searchKeyword,
      };

      try {
        const response = await getMemberList(searchObj); // API 호출
        this.searchList = response.data.data;
        return response;
      } catch (error) {
        console.log(error);
      }
    },
  },

  components: {
    PopupHeader,
    BottomApplyBtn,
  },
};
</script>

<style>
.search.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  padding: 0px 16px;
}
.search .v-icon.v-icon {
  font-size: 1.125rem;
  color: #9ca3ab;
}
.v-list .name {
  font-weight: 500;
  line-height: 1.5;
  color: #363c43;
}
.v-list .sub-desc {
  font-size: 0.875rem;
  line-height: 1.71;
  color: #505961;
}

.custom-selected {
  border-radius: 6px;
  background-color: #f5f5f5 !important; /* 밝은 회색 */
}
</style>
